import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import {
  Box,
  Container,
  Link,
  List,
  ListItem,
  Typography,
} from '@mui/material';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Privacy = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Privacy Policy to E-file IRS Forms online with TaxZerone®"
          description="TaxZerone values your privacy, and are committed to protecting the same. Privacy policy to understand how we collect, use, and disclose personal information."
          keywords="TaxZerone privacy policy, e-filing data, tax data security"
          canonical="privacy-policy/"
        />
      }
    >
      <Container
        sx={{
          mt: { xs: 2, sm: 3 },
          mb: { lg: 5, md: 5, sm: 5, xs: 3 },
          pt: { xs: 0, sm: 0 },
          mx: 'auto',
        }}
        maxWidth="lg"
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 18 },
            fontWeight: 600,
            mb: { xs: 0, sm: 3 },
          }}
        >
          Privacy policy - TaxZerone
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 2, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          At TaxZerone, we prioritize your privacy and are committed to
          protecting it. Please review our privacy policy to understand how we
          collect, use, and disclose your personal information.
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Information We Collect
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          To provide our services, we collect the following types of
          information:
        </Typography>
        <List
          sx={{
            width: { xs: '100%', md: '85%' },
            ml: { xs: -1, sm: '2%' },
            mb: 0,
          }}
        >
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Personally Identifiable Information (PII):</b> This includes
              your first and last name, date of birth, social security number
              (SSN), address, phone number, and email address. You should not
              share the PII of any third parties to which you do not have
              access.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Business Information:</b> Includes business name, employer
              identification number (EIN), and tax amount.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Individual Information: Includes your name, social security number
            (SSN), address, spouse information, and tax amount.
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Transaction Information:</b> Includes credit and debit card
              information, bank account number, and routing number. This
              information will not be stored in our database.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Device Information:</b> Includes browser type, operating
              system, and IP address.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Third-Party Information:</b> Collected to verify your identity.
            </Box>
          </ListItem>
        </List>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 1, sm: 5 },
          }}
        >
          How We Collect Your Information
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We gather your information through various channels, including:
        </Typography>
        <List
          sx={{ width: { xs: '100%', md: '85%' }, ml: { xs: -1, sm: '2%' } }}
        >
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Account creation on our website, affiliate sites, and mobile
            applications
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Direct interactions on our systems
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Subscriptions to newsletters and marketing emails
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Inquiries about our products and services
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Contacting us via chat, phone, and email
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Submitting feedback
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Signing up for contests and surveys
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box sx={{}}>
              Third-party services, such as{' '}
              <Link
                href="https://policies.google.com/privacy"
                target="_blank"
                sx={{ color: '#0202ff', wordBreak: 'break-word' }}
              >
                Google Play Services
              </Link>
            </Box>
          </ListItem>
        </List>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 1, sm: 5 },
          }}
        >
          How We Use Your Information
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          The information collected is used for purposes including but not
          limited to:
        </Typography>
        <List
          sx={{ width: { xs: '100%', md: '85%' }, ml: { xs: -1, sm: '2%' } }}
        >
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Providing our tax filing services
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Offering personalized and improved services based on your interests
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Sending communications related to your orders and for marketing
            purposes
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            Complying with legal obligations
          </ListItem>
        </List>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 1, sm: 5 },
          }}
        >
          How We Share and Disclose Your Information
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We respect your privacy and do not sell your information. We share
          your information only as described in this policy:
        </Typography>
        <List
          sx={{ width: { xs: '100%', md: '85%' }, ml: { xs: -1, sm: '2%' } }}
        >
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Internal and External Third Parties:</b> Your information is
              shared with internal third parties like APIs to provide our
              services. External third parties, such as payment gateways, will
              have access to your financial information to process payments.
              Additionally, your information will be shared with the IRS.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Government Agencies:</b> Required by law, we share your
              information with government agencies upon request.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Third Party Advertisers:</b> We <b>do not</b> share any
              personally identifiable information, such as phone numbers,
              opt-outs, consents, or mobile data, with third-party advertisers.
            </Box>
          </ListItem>
        </List>

        <Typography
          variant="h2"
          id="cookie"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 1, sm: 5 },
            scrollMarginTop: 84,
          }}
        >
          Cookie Policy
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We use cookies to remember and understand your preferences based on
          your activity on our website, and to compile aggregate data about site
          traffic and interactions. This helps us improve user experience.
          Disabling cookies may affect the functionality of some features on our
          website.
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Sharing Information with Third Parties
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We do not sell or trade your information with any third parties.
          However, we may share your information with trusted third parties for
          specific purposes:
        </Typography>
        <List
          sx={{ width: { xs: '100%', md: '85%' }, ml: { xs: -1, sm: '2%' } }}
        >
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Service Providers:</b> We share information with third-party
              service providers who perform functions on our behalf, such as
              payment processing, data analysis, and customer service.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Business Transfers:</b> In the event of a merger, acquisition,
              or sale of all or a portion of our assets, your information may be
              transferred to the new owner.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <b>Legal Requirements:</b> We may disclose your information to
              comply with legal obligations, respond to lawful requests from
              public authorities, including meeting national security or law
              enforcement requirements, and protect our rights and safety.
            </Box>
          </ListItem>
        </List>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Information Security
        </Typography>

        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We implement multiple security measures, including data encryption, to
          protect your information. Our website is regularly scanned for
          security threats. Only employees with a reasonable need have access to
          your personal information, such as our support personnel who need it
          to assist you.
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          California Online Privacy Protection Act (CalOPPA)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We comply with CalOPPA, which requires us to post a privacy policy on
          our website explaining the information we collect and how we use it.
          You have the right to access our website anonymously and will be
          notified of any changes to this policy.
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Your California Privacy Rights
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          Under the California Consumer Privacy Act (CCPA), California residents
          have the following rights:
        </Typography>
        <List sx={{ ml: { xs: -1, sm: '2%' } }}>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <strong>Right to Know:</strong> Request the personal information
              we collect about you.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <strong>Right to Request Deletion:</strong> Request the permanent
              deletion of personal information we have collected from you.
            </Box>
          </ListItem>
          <ListItem
            sx={{
              alignItems: 'flex-start',
              fontSize: { xs: 13, sm: 16, md: 16 },
            }}
          >
            <ArrowForwardRoundedIcon sx={{ mr: 1 }} />
            <Box>
              <strong>Right to Non-Discrimination:</strong> We will not
              discriminate against you for exercising your rights.
            </Box>
          </ListItem>
        </List>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          To exercise your CCPA rights, email us at{' '}
          <Link
            href="mailto:support@taxzerone.com"
            sx={{ color: '#0202FF' }}
            target="_blank"
          >
            support@taxzerone.com
          </Link>
          . We will provide the requested information within 45 days. If unable
          to do so, we will inform you of the delay and when you can expect your
          data. No additional fee is required to exercise your CCPA rights.
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Data Deletion Policy
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We value your privacy and are committed to protecting your personal
          data. This Data Deletion Policy outlines how you can request the
          deletion of your data and how we handle such requests.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 0 },
            fontSize: { xs: 13, sm: 16, md: 16 },
            fontWeight: 600,
          }}
        >
          1. User-Initiated Data Deletion
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 1 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          You may request the deletion of your personal data at any time by:
        </Typography>
        <Box component="ul" sx={{ mb: 1.5, '& li': { mb: 1 } }}>
          <li>Logging into your TaxZerone account and delete your data, or </li>
          <li>
            Contacting our support team via email, phone, or chat with your
            deletion request.{' '}
          </li>
        </Box>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 0 },
            fontSize: { xs: 13, sm: 16, md: 16 },
            fontWeight: 600,
          }}
        >
          2. Data Deletion Process
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 1 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          Upon receiving a deletion request:
        </Typography>
        <Box component="ul" sx={{ mb: 1.5, '& li': { mb: 1 } }}>
          <li>
            We will verify your identity to ensure the security of your
            data.{' '}
          </li>
          <li>
            Your data will be permanently deleted from our active databases.
          </li>
          <li>
            Backup copies may be retained for a limited period to comply with
            legal, regulatory, or security requirements.{' '}
          </li>
        </Box>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 0 },
            fontSize: { xs: 13, sm: 16, md: 16 },
            fontWeight: 600,
          }}
        >
          3. Exceptions
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 1 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          Certain data may not be deleted if:
        </Typography>
        <Box component="ul" sx={{ mb: 1.5, '& li': { mb: 1 } }}>
          <li>
            It is required to comply with legal or regulatory obligations.{' '}
          </li>
          <li>It is part of an ongoing legal process or investigation.</li>
        </Box>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          If you have any questions about our Data Deletion Policy, please
          contact our support team for assistance.
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Changes to the Privacy Policy
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          We may update this privacy policy periodically. Your continued use of
          our website after changes are made signifies your acceptance of the
          new terms.
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: { lg: 28, md: 24, sm: 20, xs: 18 },
            fontWeight: 600,
            mb: 0,
            mt: { xs: 2.5, sm: 5 },
          }}
        >
          Contact Us
        </Typography>
        <Typography
          variant="body1"
          sx={{
            my: { xs: 1, sm: 2 },
            fontSize: { xs: 13, sm: 16, md: 16 },
          }}
        >
          For any questions about our terms and policies, contact us at{' '}
          <Link
            href="mailto:support@taxzerone.com"
            sx={{ color: '#0202FF' }}
            target="_blank"
          >
            support@taxzerone.com
          </Link>
          .
        </Typography>
      </Container>
    </AppLayout>
  );
};

export default Privacy;
